import { get, set, del } from "idb-keyval"; // can use anything: IndexedDB, Ionic Storage, etc.
import devDebug from "../Helpers/debug";

const idbKeyvalAdapter = {
    getItem: async (name) => {
        // console.log(name, "has been retrieved");
        try {
            const value = await get(name);
            // idb-keyval returns undefined for "not found", Zustand expects null.
            // Also, ensure legitimate falsy values (false, 0, "") are not converted to null.
            if (value === undefined) {
                return null;
            }
            return value;
        } catch (error) {
            // Log the error or handle it if necessary, then re-throw
            // so Zustand's persist middleware can recognize the failure.
            devDebug(`IDB getItem error for key "${name}":`, error);
            throw error; // Crucial: Zustand expects errors to be thrown
        }
    },
    setItem: async (name, value) => {
        // console.log(name, "with value", value, "has been saved");
        try {
            await set(name, value);
        } catch (error) {
            devDebug(`IDB setItem error for key "${name}":`, error);
            throw error; // Crucial: Zustand expects errors to be thrown
        }
    },
    removeItem: async (name) => {
        // console.log(name, "has been deleted");
        try {
            await del(name);
        } catch (error) {
            devDebug(`IDB removeItem error for key "${name}":`, error);
            throw error; // Crucial: Zustand expects errors to be thrown
        }
    },
};

export default idbKeyvalAdapter;